{
    "scripts": {
        "clean": "rm -rf ./dist",
        "dev": "parcel public/test.html",
        "docs": "typedoc src/index.ts",
        "build": "tsc && npm run build:esm",
        "build:esm": "tsc -p ./tsconfig-esm.json",
        "prepublish": "npm run clean && npm run build",
        "test": "run -T jest --config ./jestconfig.js",
        "test:watch": "run -T jest --config ./jestconfig.js --watchAll"
    },
    "name": "@giphy/js-fetch-api",
    "version": "4.9.3",
    "main": "dist/index.js",
    "description": "Javascript API to fetch gifs and stickers from the GIPHY API.",
    "homepage": "https://github.com/Giphy/giphy-js/tree/master/packages/fetch-api",
    "types": "dist/index.d.ts",
    "module": "esm/index.js",
    "sideEffects": false,
    "exports": {
        ".": {
            "types": "./dist/index.d.ts",
            "import": "./esm/index.js",
            "require": "./dist/index.js"
        },
        "./package.json": "./package.json"
    },
    "files": [
        "dist/",
        "esm/",
        "src/**/*"
    ],
    "license": "MIT",
    "publishConfig": {
        "access": "public"
    },
    "dependencies": {
        "@giphy/js-types": "*",
        "@giphy/js-util": "*",
        "qs": "^6.9.4"
    },
    "devDependencies": {
        "@types/qs": "^6.9.4",
        "jest-fetch-mock": "^3.0.3",
        "parcel-bundler": "latest",
        "typedoc": "^0.20.36",
        "typedoc-thunder-theme": "^0.0.2",
        "typescript": "^5.0.4"
    }
}
